export default "__VITE_ASSET__BAdvYFOS__"